export class CognitoAuthenticatedUser {
  sub?: string;
  email_verified: boolean;
  email: string;

  constructor(email_verified: boolean, email: string, sub?: string) {
    this.sub = sub;
    this.email_verified = email_verified;
    this.email = email;
  }
}
